import React from "react";
import { cn } from "@repo/blacksmith-ui/cn";

interface CodesmithIconProps {
  className?: string;
}

export function CodesmithIcon({ className }: CodesmithIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-[18px] shrink-0", className)}
    >
      <path
        d="M8 18H22V20H6V16H8V18ZM24 18H22V6H24V18ZM6 16H4V14H6V16ZM2 12H4V14H0V6H2V12ZM12 14H10V8H12V14ZM18 14H16V8H18V14ZM22 6H2V4H22V6Z"
        fill="currentColor"
      />
    </svg>
  );
}
